import { Component } from '@angular/core';
import { ReusableGridComponent } from '../../components/library/reusable-grid/reusable-grid.component';
import { DataServiceService } from '../../services/data-service.service';
import { ActionIDs } from '../../shared/enums/tables.enum';

@Component({
  selector: 'app-country-grid',
  templateUrl: './country-grid.component.html',
  styleUrl: './country-grid.component.scss',
  imports: [ReusableGridComponent],
  standalone: true
})
export class CountryGridComponent {
  public ActionIDs = ActionIDs;

  countryDataSource: any;

  columns = [
    { dataField: 'Id', caption: 'ID', dataType: 'string', hidingPriority: 7, validationRules: [{ type: 'required' }] },
    { dataField: 'Name', caption: 'Name', dataType: 'string', hidingPriority: 6, validationRules: [{ type: 'required' }] },
    { dataField: 'Description', caption: 'Description', dataType: 'string', hidingPriority: 5 },
  ];

  constructor(private dataService: DataServiceService) {
    this.countryDataSource = dataService.getCountryDataSource();
  }
}
